import { ItemLinkEntity } from '../entity';
import { CodeStatus } from '../shared/code';
import { CodeType } from '../shared/code.type';
import { CodeUoM } from '../shared/uom';
import { TaxRate } from '../taxrate/tax.rate';

export enum TaxInclusiveOption {
    Exclusive = 'Tax Exclusive',
    Inclusive = 'Tax Inclusive',
    NoTax = 'No Tax'
}

export interface PurchaseOrderLine {
    _id?: string
    name?: string;
    description?: string;
    quantity?: number;
    price?: number;
    customPrice?: boolean;

    tax: number;
    subTotal: number;
    total: number;
    location?: string;
    notes?: string;
    codeStatus?: CodeStatus;
    uom?: string;
    codeUoM?: CodeUoM;
    itemLink?: ItemLinkEntity;
    // billLink?: ItemLinkEntity;

    glCode?: string;
    taxRate?: TaxRate;
    type?: CodeType;
    catalogueCodeId?: string;
    createFromCode?: boolean;
    canOverrideDesc?: boolean;
}
